/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Flex,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  useSteps,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { CASH_CENTER_DEFAULT, CASH_CENTER_INFORMATION } from "../constants";
import Loader from "../../../components/PageLoader";
import BreadCrumb from "../../../components/breadCrumb";
import { Paths } from "../../../routes/paths";
import ContactPerson from "../../customers/addCustomer/contact-persons";
import EscalationGroups from "../../customers/addCustomer/escalation-groups";
import { useLookupCurrency } from "../../../services/lookups-queries";
import { useAddCashCenter } from "../../../services/cash-center";
import Information from "./information";
import Offices from "./offices";
import OperationalWindow from "./operational-window";
import InsuranceLimits from "./Insurance-limits";
import InternalSLAs from "./internal-SLAS";
import Summary from "./summary";

const steps = [
  { title: "Information" },
  { title: "Offices" },
  { title: "Timings & Insurance" },
  { title: "Contacts" },
  { title: "Escalations" },
  { title: "SLAs" },
];
export default function AddCashCenter() {
  const [triggerValidation, setTriggerValidation] = useState(false);
  const [cashCenter, setCashCenter] = useState({ ...CASH_CENTER_DEFAULT });
  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });
  const { data: currencyListRes } = useLookupCurrency();
  const {
    mutate: createRequest,
    isSuccess: isRequestCreated,
    isPending: creatingCashCenter,
  } = useAddCashCenter();
  const navigate = useNavigate();
  useEffect(() => {
    if (isRequestCreated) {
      setActiveStep(1);
      navigate(Paths.cashCenter);
    }
  }, [isRequestCreated]);
  const getCashCenterInformation = useMemo(
    () => ({
      name: cashCenter.name,
      type: cashCenter.type,
      primaryCurrency: cashCenter.primaryCurrency,
      barcode: cashCenter.barcode,
      locationId: cashCenter.locationId,
      status: cashCenter.status,
      longitude: cashCenter.longitude,
      latitude: cashCenter.latitude,
      loadingBayArea: cashCenter.loadingBayArea,
      loadingBayCapacity: cashCenter.loadingBayCapacity,
      country: cashCenter.country,
      state: cashCenter.state,
      emirate: cashCenter.emirate,
      city: cashCenter.city,
      postalCode: cashCenter.postalCode,
      address: cashCenter.address,
      firstServiceDate: cashCenter.firstServiceDate,
      inactiveDate: cashCenter.inactiveDate,
      serviceDays: cashCenter.serviceDays,
    }),
    [cashCenter]
  );
  const updateCashCenterInformation = (information) => {
    const _cashCenter = {
      ...cashCenter,
      name: information.name,
      type: information.type,
      primaryCurrency: information.primaryCurrency,
      barcode: information.barcode,
      locationId: information.locationId,
      status: information.status,
      longitude: information.longitude,
      latitude: information.latitude,
      loadingBayArea: information.loadingBayArea,
      loadingBayCapacity: information.loadingBayCapacity,
      country: information.country,
      state: information.state,
      emirate: information.emirate,
      city: information.city,
      postalCode: information.postalCode,
      address: information.address,
      firstServiceDate: information.firstServiceDate,
      inactiveDate: information.inactiveDate,
      serviceDays: information.serviceDays,
    };
    setCashCenter(_cashCenter);
  };

  const getOffices = useMemo(() => {
    return [...cashCenter.offices.map((elm) => ({ ...elm, expanded: false }))];
  }, [cashCenter]);

  const setOffices = (offices) => {
    const _cashCenter = { ...cashCenter };
    _cashCenter.offices = [...offices];
    setCashCenter(_cashCenter);
  };
  const getOperationalWindows = useMemo(() => {
    return [...cashCenter.operationalWindows];
  }, [cashCenter]);

  const setOperationalWindows = (operationalWindows) => {
    const _cashCenter = { ...cashCenter };
    _cashCenter.operationalWindows = operationalWindows;
    setCashCenter(_cashCenter);
  };
  const getInsuranceLimit = useMemo(() => {
    return [...cashCenter.insuranceLimits];
  }, [cashCenter]);
  const setInsuranceLimits = (insuranceLimits) => {
    const _cashCenter = { ...cashCenter };
    _cashCenter.insuranceLimits = insuranceLimits;
    setCashCenter(_cashCenter);
  };
  const getContactPersons = useMemo(() => {
    return [...cashCenter.contactPersons];
  }, [cashCenter]);
  const setContactPersons = (contactPersons) => {
    const _cashCenter = { ...cashCenter };
    _cashCenter.contactPersons = contactPersons;
    setCashCenter(_cashCenter);
  };
  const getEscalationGroups = useMemo(() => {
    return [...cashCenter.escalationGroups];
  }, [cashCenter]);
  const setEscalationGroups = (escalationGroups) => {
    const _cashCenter = { ...cashCenter };
    _cashCenter.escalationGroups = escalationGroups;
    setCashCenter(_cashCenter);
  };
  const getInternalSLAs = useMemo(() => {
    return [...cashCenter.internalSLAs];
  }, [cashCenter]);
  const setInternalSLAs = (internalSLAs) => {
    const _cashCenter = { ...cashCenter };
    _cashCenter.internalSLAs = internalSLAs;
    setCashCenter(_cashCenter);
  };

  const {
    handleSubmit,
    control,
    watch,
    resetField,
    setValue,
    getValues,
    trigger,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: { ...CASH_CENTER_INFORMATION },
  });
  useEffect(() => {
    if (activeStep === 1 && triggerValidation) {
      trigger();
    } else if (activeStep !== 1 && triggerValidation) {
      setTriggerValidation(false);
    }
  }, [triggerValidation, activeStep]);

  return (
    <>
      {creatingCashCenter ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Cash Centers", link: Paths.cashCenter },
            { text: "Create Cash Centers", isCurrentPage: true },
          ]}
        />
        <Stepper index={activeStep} size="sm" className="extra-small-stepper">
          {steps.map((step, index) => (
            <Step
              key={index}
              onClick={() => {
                if (activeStep === 1) {
                  updateCashCenterInformation(getValues());
                }
                setActiveStep(index + 1);
              }}
            >
              <StepIndicator style={{ cursor: "pointer" }}>
                <StepStatus
                  complete={<StepIcon />}
                  incomplete={<StepNumber />}
                  active={<StepNumber />}
                />
              </StepIndicator>

              <div style={{ cursor: "pointer" }}>
                <StepTitle>{step.title}</StepTitle>
                <StepDescription>{step.description}</StepDescription>
              </div>

              <StepSeparator />
            </Step>
          ))}
        </Stepper>
        <Flex w="100%" mt="20px">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div className="add-location-form">
                {activeStep === 1 ? (
                  <form>
                    <Information
                      cashCenterInformation={getCashCenterInformation}
                      currencies={currencyListRes?.data || []}
                      onNextStep={() => {
                        setActiveStep(2);
                        updateCashCenterInformation(getValues());
                      }}
                      handleSubmit={handleSubmit}
                      control={control}
                      errors={errors}
                      watch={watch}
                      resetField={resetField}
                      setValue={setValue}
                    />
                  </form>
                ) : activeStep === 2 ? (
                  <Offices
                    offices={getOffices}
                    onPrevStep={(data) => {
                      setActiveStep(1);
                      setOffices(data);
                    }}
                    onNextStep={() => {
                      setActiveStep(3);
                    }}
                    addData={(data) => {
                      setOffices(data);
                    }}
                  />
                ) : activeStep === 3 ? (
                  <>
                    <OperationalWindow
                      operationalWindows={getOperationalWindows}
                      onNextStep={(data) => {
                        setOperationalWindows(data);
                        setActiveStep(4);
                      }}
                      onPrevStep={(data) => {
                        setOperationalWindows(data);
                        setActiveStep(2);
                      }}
                      addData={(data) => {
                        setOperationalWindows(data);
                      }}
                    />
                    <InsuranceLimits
                      currencies={currencyListRes?.data || []}
                      insuranceLimits={getInsuranceLimit}
                      updateDate={(data) => {
                        setInsuranceLimits(data);
                      }}
                    />
                  </>
                ) : activeStep === 4 ? (
                  <ContactPerson
                    contactPersons={getContactPersons}
                    onPrevStep={(data) => {
                      setActiveStep(3);
                      setContactPersons(data);
                    }}
                    onNextStep={(data) => {
                      setActiveStep(5);
                      setContactPersons(data);
                    }}
                    addData={(data) => {
                      setContactPersons(data);
                    }}
                  />
                ) : activeStep === 5 ? (
                  <EscalationGroups
                    escalationGroups={getEscalationGroups}
                    onPrevStep={(data) => {
                      setActiveStep(4);
                      setEscalationGroups(data);
                    }}
                    onNextStep={(data) => {
                      setActiveStep(6);
                      setEscalationGroups(data);
                    }}
                    addData={(data) => {
                      setEscalationGroups(data);
                    }}
                  />
                ) : activeStep === 6 ? (
                  <InternalSLAs
                    SLAs={getInternalSLAs}
                    onPrevStep={(data) => {
                      setActiveStep(5);
                      setInternalSLAs(data);
                    }}
                    onNextStep={(data) => {
                      setInternalSLAs(data);
                      if (isValid) {
                        setActiveStep(7);
                      } else {
                        setActiveStep(1);
                        setTriggerValidation(true);
                      }
                    }}
                    addData={(data) => {
                      setInternalSLAs(data);
                    }}
                  />
                ) : activeStep === 7 ? (
                  <Summary
                    cashCenter={cashCenter}
                    editing={false}
                    onPrevStep={() => {
                      setActiveStep(6);
                    }}
                    onCreateCashCenter={(data) => {
                      createRequest(data);
                    }}
                  />
                ) : (
                  <></>
                )}
              </div>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
